module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x20_small-d504bc383989919f7a12f996e9505eef.png";